export { default as Theme } from '../old-button/custom-theme-button/theme';
export { default } from '../old-button/custom-theme-button/custom-theme-button';
export type {
	ThemeTokens,
	ThemeProps,
	InteractionState,
	CustomThemeButtonProps,
	CustomThemeButtonOwnProps,
} from '../old-button/custom-theme-button/custom-theme-button-types';
